<div class="full-page">
  <div class="container">
    <div class="w-100 text-center mt-3">
      <img class="logo mb-4" src="assets/images/rewards-logo.png" draggable="false" />
    </div>
    <div class="reg-background">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
